import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../styles/leis-auth.scss'
import moment from "moment";

const Lei = (props) => {
    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });
    const dataP = moment(props.lei.data_p).utc(false).format("DD/MM/YYYY")
    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchLeisIn()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    const setData = async (id) => {
        props.data(id)
    }
    const setJornal = async (id) => {
        props.jornal(id)
    }
    const setEmenta = async (id) => {
        props.ementa(id)
    }
    const setArquivo = async (id) => {
        props.arquivo(id)
    }

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Row xs={1} lg={2}>
                        <Col>
                            <Card.Body>
                                <Card.Title className="cabeca-card" key={props.key}>{props.lei.categoria} Nº{props.lei.num_lei}/{props.lei.ano}
                                    {props.lei.data_p ? <p>{dataP}</p> : null}
                                    {props.lei.jornal ? <p>{props.lei.jornal}</p> : null}
                                    {props.lei.ementa ? <p>{props.lei.ementa}</p> : null}
                                </Card.Title>
                            </Card.Body>
                        </Col>
                        <Col>
                            <Row>
                                <Button type="button" className="botao-leis" onClick={() => editar(props.lei._id)} variant='primary'>Editar</Button>
                                <Button type="button" className="botao-leis" onClick={() => setData(props.lei._id)} variant='primary'>Mudar Data da Lei</Button>
                                <Button type='button' className="botao-leis" onClick={() => setJornal(props.lei._id)} variant='primary'>Mudar Categoria</Button>
                            </Row>
                            <Row>
                                <Button type='button' className="botao-leis" onClick={() => setEmenta(props.lei._id)} variant='primary'>Mudar Ementa</Button>
                                <Button type='button' className="botao-leis" onClick={() => setArquivo(props.lei._id)} variant='primary'>Mudar Arquivo</Button>
                                <Button type='button' className="botao-leis" onClick={() => deletar(props.lei._id)} variant='danger'>Excluir</Button>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Fragment >)
}

export default Lei;